import type { LocalSettings } from "@app/config/LocalSettings";
import localSettings from "@app/config/LocalSettings";

class ActivitySettings {
  settings: LocalSettings;

  private readonly SHARED_ACTIVITIES_VISIBILITY = "__SHARED_ACTIVITIES_VISIBILITY__";

  constructor(settings: LocalSettings) {
    this.settings = settings;
  }

  getSharedActivitiesVisibility = (): boolean => {
    try {
      const showSharedActivities: unknown = JSON.parse(
        localStorage.getItem(this.SHARED_ACTIVITIES_VISIBILITY) ?? ""
      );
      return !!showSharedActivities;
    } catch {
      return false;
    }
  };

  setSharedActivitiesVisibility = (visible: boolean) => {
    localStorage.setItem(this.SHARED_ACTIVITIES_VISIBILITY, JSON.stringify(visible));
  };
}

const activitySettings = new ActivitySettings(localSettings);

export default activitySettings;
